module.exports = __webpack_public_path__ + "img/gonggao.3a7c09bc.png";